// src/auth/RequireAuth.js


// src/auth/RequireAuth.js
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./useAuth";

export default function RequireAuth() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // ✅ NE JAMAIS bloquer le callback SSO
  if (location.pathname.startsWith("/sso/callback")) {
    return <Outlet />;
  }

  // Protection standard
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}


/*
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';

export default function RequireAuth() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}

*/

/*import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './useAuth';

export default function RequireAuth() {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
}*/
